"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseComponent = exports.BASE_COMPONENT_TYPE_FLAG = void 0;
var index_1 = require("../index");
var componentService_1 = require("./componentService");
var components_1 = require("../utils/components");
var config_1 = require("../config/config");
/** @internal */
exports.BASE_COMPONENT_TYPE_FLAG = Symbol('SalvoComponent');
// This shim replaces HTMLElement with a dummy class when running under node,
// which allows the metadata generation scripts to run.
// eslint-disable-next-line @typescript-eslint/naming-convention
var HTMLElement = (typeof window !== 'undefined' && window.HTMLElement) || /** @class */ (function () {
    function NodeDummyClass() {
    }
    return NodeDummyClass;
}());
/**
 * Base component that all SALVO components inherit from.
 * @noInheritDoc
 */
var BaseComponent = /** @class */ (function (_super) {
    __extends(BaseComponent, _super);
    /**
     * Do not call component constructors directly. Instead, use document.createElement with the component's tag!
     */
    function BaseComponent() {
        var _this = _super.call(this) || this;
        // Used by isComponent
        /* @internal */
        _this.$type = exports.BASE_COMPONENT_TYPE_FLAG;
        // Lifecycle flags
        /** @internal */
        _this.$isInit = false;
        // State
        /** @internal */
        _this.$propWatchers = {};
        _this._$log = null;
        /**
         * Event helpers
         */
        _this.$eventListeners = [];
        _this.$unsubCallbacks = [];
        // Get component info
        var def = componentService_1.componentService.components.findByCtor(_this.constructor);
        if (!def) {
            throw new Error("Cannot create instance of component ".concat(_this.constructor.name, " - not registered."));
        }
        // Copy component info to instance
        _this.$info = def;
        _this.$name = def.name;
        _this.$log.internal('Constructed', {
            instance: _this,
        });
        return _this;
    }
    /** @internal */
    BaseComponent.prototype.$onPropUpdated = function (propDef, value) {
        var e_1, _a;
        this.$log.debug('PROP UPDATED', {
            propDef: propDef,
            value: value,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            direct: this[propDef.propertyKey],
        });
        if (propDef.reflectAttr) {
            if (value.toString()) {
                this.$log.debug('SET ATTR', {
                    propDef: propDef,
                    value: value
                });
                this.setAttribute(propDef.attr, value.toString());
            }
            else {
                // TODO
            }
        }
        // Trigger prop watches
        var watchers = this.$propWatchers[propDef.propertyKey] || [];
        try {
            for (var watchers_1 = __values(watchers), watchers_1_1 = watchers_1.next(); !watchers_1_1.done; watchers_1_1 = watchers_1.next()) {
                var cb = watchers_1_1.value;
                cb(value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (watchers_1_1 && !watchers_1_1.done && (_a = watchers_1.return)) _a.call(watchers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** @internal */
    BaseComponent.prototype.$resolvePropValue = function (prop) {
        var propVal = this.getAttribute(prop.attr);
        var finalVal;
        if (propVal !== null) {
            var simpleTypes = [
                'String', 'Number', 'Date', 'Function',
            ];
            if (simpleTypes.indexOf(prop.propertyTypeName) > -1 && typeof prop.propertyType == 'function') {
                finalVal = prop.propertyType(propVal);
            }
            else if (prop.propertyTypeName == 'Boolean') {
                if (propVal === 'true' || propVal === '1') {
                    finalVal = true;
                }
                else if (propVal === 'false' || propVal === '0') {
                    finalVal = false;
                }
                else {
                    throw new Error("Boolean prop ".concat(prop.attr, " passed invalid value \"").concat(propVal, "\""));
                }
            }
            else {
                var record = JSON.parse(propVal);
                if (!record) {
                    throw new Error("Prop ".concat(prop.attr, " passed invalid JSON!"));
                }
                var convertable = prop.propertyType;
                if (convertable.fromSalvoPropValue) {
                    finalVal = convertable.fromSalvoPropValue(record);
                }
                if (['object', 'array'].indexOf(typeof record) == -1) {
                    finalVal = record;
                }
                else {
                    finalVal = new prop.propertyType();
                    Object.assign(finalVal, record);
                }
            }
        }
        else {
            if (prop.default === undefined) {
                throw new Error("Required prop ".concat(prop.attr, " (").concat(prop.propertyKey, ") not passed!"));
            }
            finalVal = prop.default;
        }
        return finalVal;
    };
    /** @internal */
    BaseComponent.prototype.$resolveRefValue = function (ref, getComponentRef) {
        var _this = this;
        var refEls = this.querySelectorAll(ref.selector) || [];
        var resolveRef = function (el) {
            // TODO: is this defunct?
            if (!(0, components_1.isComponent)(el) && el.tagName.indexOf('-') > -1) {
                throw new Error("Ref ".concat(ref.selector, " (").concat(ref.propertyKey, ") has issues - ") +
                    "Element was found and type was interpreted as component ref - element looks " +
                    "like a component, but isn't registered. Maybe you have a typo in the component tag?");
            }
            _this.$log.debug('resolve ref', {
                ref: ref,
                el: el,
            });
            return el;
        };
        if (ref.propertyTypeName == 'Array') {
            if (config_1.debug) {
                this.$log.warn("Array refs can't be typechecked currently - if you encounter weird issues, ensure that "
                    + "elements for ref '".concat(ref.selector, "' all all expected element type."));
            }
            if (refEls.length < 1 && ref.required) {
                throw new Error("Required ref ".concat(ref.selector, " (").concat(ref.propertyKey, ") not found! (This is an array ref ")
                    + "- if you want to allow an empty array set required to false in the Ref options)");
            }
            return Array.from(refEls).map(function (el) { return resolveRef(el); });
        }
        else {
            if (!refEls[0]) {
                if (ref.required) {
                    throw new Error("Required ref ".concat(ref.selector, " (").concat(ref.propertyKey, ") not found!"));
                }
                return null;
            }
            if (refEls.length > 1) {
                throw new Error("Duplicate elements with same ref: ".concat(ref.selector, ". If this is intention, change ")
                    + "the ref to an array type to reflect this.");
            }
            return resolveRef(refEls[0]);
        }
    };
    /**
     * Web Component hooks
     */
    /** @internal */
    BaseComponent.prototype.connectedCallback = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        componentService_1.componentService.instanceConnected(this);
                        return [4 /*yield*/, componentService_1.componentService.bootstrapped];
                    case 1:
                        _a.sent();
                        if (!this.isConnected) {
                            componentService_1.componentService.instanceDisconnected(this);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.$beforeInit()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, componentService_1.componentService.ready];
                    case 3:
                        _a.sent();
                        if (!!this.$isInit) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.$init()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(BaseComponent, "observedAttributes", {
        /** @internal */
        get: function () {
            var def = componentService_1.componentService.components.findByCtor(this);
            return (def === null || def === void 0 ? void 0 : def.props.map(function (p) { return p.attr; })) || [];
        },
        enumerable: false,
        configurable: true
    });
    /** @internal */
    BaseComponent.prototype.attributeChangedCallback = function (name, oldValue, newValue) {
        var e_2, _a;
        try {
            for (var _b = __values(this.$info.props), _c = _b.next(); !_c.done; _c = _b.next()) {
                var propDef = _c.value;
                if (propDef.attr == name && propDef.reflectAttr && newValue !== null) {
                    var simpleTypes = [
                        'String', 'Number', 'Date', 'Function',
                    ];
                    var finalVal = void 0;
                    if (simpleTypes.indexOf(propDef.propertyTypeName) > -1 && typeof propDef.propertyType == 'function') {
                        finalVal = propDef.propertyType(newValue);
                    }
                    else {
                        var record = JSON.parse(newValue);
                        if (!record) {
                            throw new Error("Prop ".concat(propDef.attr, " passed invalid JSON!"));
                        }
                        var convertable = propDef.propertyType;
                        if (convertable.fromSalvoPropValue) {
                            finalVal = convertable.fromSalvoPropValue(record);
                        }
                        else {
                            finalVal = new propDef.propertyType();
                            Object.assign(finalVal, record);
                        }
                    }
                    if (this[propDef.propertyKey] !== finalVal) {
                        this[propDef.propertyKey] = finalVal;
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        // TODO
        this.attributeChanged(name, oldValue, newValue);
    };
    /**
     * Called every time an element attribute is changed.
     * @param name Name of the attribute which was changed
     * @param oldValue Old value of the attribute
     * @param newValue New value of the attribute
     */
    BaseComponent.prototype.attributeChanged = function (name, oldValue, newValue) {
    };
    /**
     * Runs a callback whenever a certain prop is changed
     * @param key Prop to watch
     * @param cb Callback to run when changed
     * @deprecated Use Watch decorator
     * @internal
     */
    BaseComponent.prototype.$watchProp = function (key, cb) {
        if (!this.$propWatchers[key.toString()]) {
            this.$propWatchers[key.toString()] = [];
        }
        this.$propWatchers[key.toString()].push(cb);
    };
    Object.defineProperty(BaseComponent.prototype, "$log", {
        /**
         * General helpers
         */
        /**
         * Instance of a logger which uses this component's name as it's tag.
         */
        get: function () {
            if (!this._$log) {
                this._$log = new index_1.TaggedLog(index_1.log, this.$name);
            }
            return this._$log;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Registers an event listener that is automatically removed when
     * this component is destroyed.
     */
    BaseComponent.prototype.$listen = function (el, eventName, callback) {
        var wrappedCallback = function (e) {
            callback(e);
        };
        this.$eventListeners.push({
            el: el,
            eventName: eventName.toString(),
            wrappedCallback: wrappedCallback
        });
        el.addEventListener(eventName.toString(), wrappedCallback);
    };
    BaseComponent.prototype.$unregisterEventListeners = function () {
        var e_3, _a, e_4, _b;
        try {
            for (var _c = __values(this.$eventListeners), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = _d.value, el = _e.el, eventName = _e.eventName, wrappedCallback = _e.wrappedCallback;
                el.removeEventListener(eventName, wrappedCallback);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
        try {
            for (var _f = __values(this.$unsubCallbacks), _g = _f.next(); !_g.done; _g = _f.next()) {
                var cb = _g.value;
                cb();
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    BaseComponent.prototype.$subscribe = function (evt, listener) {
        var unsub = evt.subscribe(listener);
        this.$unsubCallbacks.push(unsub);
        return unsub;
    };
    /**
     * Lifecycle hooks
     */
    /** @internal */
    BaseComponent.prototype.$beforeInit = function () {
        var e_5, _a, e_6, _b;
        this.$log.info('Initing refs');
        try {
            try {
                for (var _c = __values(this.$info.refs), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var refDef = _d.value;
                    var refEl = this.$resolveRefValue(refDef, componentService_1.componentService.instances.findByElement.bind(componentService_1.componentService.instances));
                    this[refDef.propertyKey] = refEl;
                    this.$log.debug('SET REF VAL', {
                        prop: refDef.propertyKey,
                        val: refEl,
                    });
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        catch (e) {
            this.$log.error("".concat(e), {
                componentName: this.$name,
                el: this,
            });
            // TODO
        }
        this.$log.info('Initing props');
        try {
            // TODO
            this.$log.debug('initing props', {
                t: this,
                props: this.$info.props,
            });
            try {
                for (var _e = __values(this.$info.props), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var propDef = _f.value;
                    var propVal = this.$resolvePropValue(propDef);
                    this[propDef.propertyKey] = propVal;
                    this.$log.debug('SET PROP VAL', {
                        prop: propDef.propertyKey,
                        val: propVal,
                    });
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        catch (e) {
            this.$log.error("".concat(e), {
                componentName: this.$name,
                el: this,
            });
            //this.instances.remove(instance);
        }
        this.$log.info('ready');
    };
    /**
     * Called when the component should perform it's setup.
     *
     * The component should hook up any event listeners.
     * #el will be populated, as will the values of any
     * props or refs.
     */
    BaseComponent.prototype.init = function () {
    };
    /** @internal */
    BaseComponent.prototype.$init = function () {
        this.$isInit = true;
        return this.init();
    };
    /** @internal */
    BaseComponent.prototype.disconnectedCallback = function () {
        componentService_1.componentService.instanceDisconnected(this);
        if (this.$isInit) {
            this.$isInit = false;
            this.$destroy();
        }
    };
    /** @internal */
    BaseComponent.prototype.$destroy = function () {
        // Destroy any known event listeners
        this.$unregisterEventListeners();
        this.$isInit = false;
    };
    /**
     * Called when the component is removed from the page
     */
    BaseComponent.prototype.destroy = function () {
        // TODO
    };
    return BaseComponent;
}(HTMLElement));
exports.BaseComponent = BaseComponent;
//# sourceMappingURL=BaseComponent.js.map